export default [{
    _name: 'CSidebarNav',
    _children: [{
            _name: 'CSidebarNavTitle',
            _children: ['']
        },
        {
            _name: 'CSidebarNavItem',
            name: 'Productos',
            to: '/Dashboard',
            icon: 'cil-basket'
        },
        /*{
            _name: 'CSidebarNavItem',
            name: 'Asistencias',
            to: '/asistencias',
            icon: 'cil-check-circle'
        },
        {
            _name: 'CSidebarNavItem',
            name: 'Ayuda',
            to: '/ayuda',
            icon: 'cil-group'
        },*/



        // Infonavit
        /*{
            _name: 'CSidebarNavTitle',
            _children: ['Infonavit']
        },
        {
            _name: 'CSidebarNavDropdown',
            name: 'Facturas',
            route: '/facturas',
            icon: 'cil-puzzle',
            items: [{
                    name: 'Consulta',
                    to: '/infonavit/consulta'
                },
                {
                    name: 'Cards',
                    to: '/facturas/cards'
                },
            ]
        },*/

        // Proveedores
        /*{
            _name: 'CSidebarNavTitle',
            _children: ['Proveedores']
        },
        {
            _name: 'CSidebarNavDropdown',
            name: 'Proveedores',
            route: '/proveedores',
            icon: 'cil-puzzle',
            items: [{
                    name: 'Consulta',
                    to: '/proveedores/consulta'
                },
                {
                    name: 'Órdenes de compra',
                    to: '/proveedores/ordenes-de-compra'
                },
                {
                    name: 'CFDI´s',
                    to: '/proveedores/cfdis'
                },
            ]
        },*/

        //Clientes
        {
            _name: 'CSidebarNavTitle',
            _children: ['Clientes']
        },
        {
            _name: 'CSidebarNavDropdown',
            name: 'Clientes',
            route: '/clientes',
            icon: 'cil-puzzle',
            items: [
                {
                    name: 'Consulta Solicitudes',
                    to: '/clientes/solicitudes'
                },
                {
                    name: 'Consulta Cliente',
                    to: '/clientes/consulta'
                },
                {
                    name: 'Órdenes de compra Cliente',
                    to: '/clientes/ordenes-de-compra'
                },
                {
                    name: 'CFDIs Cliente',
                    to: '/clientes/cfdis'
                },
            ]
        },

    ]
}]